"use client";

import { c as _c } from "react/compiler-runtime";
import { MemeSeason } from "@/entities/ISeason";
import { commonApiFetch } from "@/services/api/common-api";
import { useAnimate } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import SeasonsGridDropdownItemsWrapper from "./SeasonsGridDropdownItemsWrapper";
interface SeasonsGridDropdownProps {
  readonly selected: MemeSeason | null;
  readonly setSelected: (season: MemeSeason | null) => void;
  readonly initialSeasonId?: number | null;
  readonly disabled?: boolean;
}
export default function SeasonsGridDropdown(t0) {
  const $ = _c(56);
  const {
    selected,
    setSelected,
    initialSeasonId,
    disabled: t1
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const [isOpen, setIsOpen] = useState(false);
  const [iconScope, animateIcon] = useAnimate();
  const buttonRef = useRef(null);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const [seasons, setSeasons] = useState(t2);
  const [initialApplied, setInitialApplied] = useState(false);
  let t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      const abortController = new AbortController();
      commonApiFetch({
        endpoint: "new_memes_seasons",
        signal: abortController.signal
      }).then(response => {
        setSeasons(response);
      }).catch(_temp);
      return () => {
        abortController.abort();
      };
    };
    t4 = [];
    $[1] = t3;
    $[2] = t4;
  } else {
    t3 = $[1];
    t4 = $[2];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[3] !== initialApplied || $[4] !== initialSeasonId || $[5] !== seasons || $[6] !== selected || $[7] !== setSelected) {
    t5 = () => {
      if (seasons.length === 0) {
        return;
      }
      if (initialApplied) {
        return;
      }
      if (selected !== null) {
        return;
      }
      if (!initialSeasonId) {
        return;
      }
      const matchedSeason = seasons.find(s => s.id === initialSeasonId);
      if (matchedSeason) {
        setSelected(matchedSeason);
        setInitialApplied(true);
      }
    };
    t6 = [initialSeasonId, seasons, initialApplied, setSelected, selected];
    $[3] = initialApplied;
    $[4] = initialSeasonId;
    $[5] = seasons;
    $[6] = selected;
    $[7] = setSelected;
    $[8] = t5;
    $[9] = t6;
  } else {
    t5 = $[8];
    t6 = $[9];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[10] !== animateIcon || $[11] !== iconScope || $[12] !== isOpen) {
    t7 = () => {
      if (!iconScope.current) {
        return;
      }
      if (isOpen) {
        animateIcon(iconScope.current, {
          rotate: 0
        });
      } else {
        animateIcon(iconScope.current, {
          rotate: -90
        });
      }
    };
    t8 = [animateIcon, iconScope, isOpen];
    $[10] = animateIcon;
    $[11] = iconScope;
    $[12] = isOpen;
    $[13] = t7;
    $[14] = t8;
  } else {
    t7 = $[13];
    t8 = $[14];
  }
  useEffect(t7, t8);
  let t9;
  if ($[15] !== selected) {
    t9 = () => {
      if (selected === null) {
        return "All Seasons";
      }
      return selected.display;
    };
    $[15] = selected;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const getLabel = t9;
  let t10;
  if ($[17] !== setSelected) {
    t10 = season => {
      setSelected(season);
      setIsOpen(false);
    };
    $[17] = setSelected;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const onSelect = t10;
  let t11;
  if ($[19] !== getLabel) {
    t11 = getLabel();
    $[19] = getLabel;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  const t12 = `Season: ${t11}`;
  let t13;
  if ($[21] !== isOpen) {
    t13 = () => setIsOpen(!isOpen);
    $[21] = isOpen;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  const t14 = `${disabled ? "tw-opacity-50 tw-text-iron-400" : "hover:tw-ring-iron-600 tw-text-iron-300"} tw-bg-iron-800 lg:tw-bg-iron-900 tw-py-3 tw-w-full tw-truncate tw-text-left tw-relative tw-block tw-whitespace-nowrap tw-rounded-lg tw-border-0 tw-pl-3.5 tw-pr-10 tw-font-semibold tw-caret-primary-400 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-700 
          focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400 tw-text-sm hover:tw-bg-iron-800 tw-transition tw-duration-300 tw-ease-out tw-justify-between`;
  let t15;
  if ($[23] !== getLabel) {
    t15 = getLabel();
    $[23] = getLabel;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== iconScope) {
    t17 = <div className="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center -tw-mr-1 tw-pr-3.5"><svg ref={iconScope} className="tw-h-5 tw-w-5" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">{t16}</svg></div>;
    $[26] = iconScope;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== disabled || $[29] !== isOpen || $[30] !== t12 || $[31] !== t13 || $[32] !== t14 || $[33] !== t15 || $[34] !== t17) {
    t18 = <div className="tw-relative tw-w-full"><button ref={buttonRef} type="button" aria-haspopup="true" aria-label={t12} aria-expanded={isOpen} onClick={t13} disabled={disabled} className={t14}>{t15}{t17}</button></div>;
    $[28] = disabled;
    $[29] = isOpen;
    $[30] = t12;
    $[31] = t13;
    $[32] = t14;
    $[33] = t15;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== onSelect) {
    t19 = () => onSelect(null);
    $[36] = onSelect;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  const t20 = `tw-col-span-full tw-w-full tw-flex tw-items-center tw-justify-center tw-gap-x-2 tw-rounded-md tw-border tw-border-solid tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-transition tw-duration-200 tw-ease-out focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary-400 ${selected === null ? "tw-bg-primary-500/20 tw-border-primary-500 tw-text-primary-300" : "tw-bg-transparent tw-border-iron-700 tw-text-iron-200 hover:tw-bg-iron-800"}`;
  let t21;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <span>All Seasons</span>;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] !== t19 || $[40] !== t20) {
    t22 = <button type="button" onClick={t19} className={t20} role="menuitem">{t21}</button>;
    $[39] = t19;
    $[40] = t20;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  let t23;
  if ($[42] !== onSelect || $[43] !== seasons || $[44] !== selected?.id) {
    let t24;
    if ($[46] !== onSelect || $[47] !== selected?.id) {
      t24 = season_0 => <button key={season_0.id} type="button" onClick={() => onSelect(season_0)} className={`tw-flex tw-items-center tw-justify-center tw-gap-x-1 tw-rounded-md tw-border tw-border-solid tw-px-2 tw-py-2 tw-text-sm tw-font-medium tw-transition tw-duration-200 tw-ease-out focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary-400 ${selected?.id === season_0.id ? "tw-bg-primary-500/20 tw-border-primary-500 tw-text-primary-300" : "tw-bg-transparent tw-border-iron-700 tw-text-iron-200 hover:tw-bg-iron-800"}`} role="menuitem"><span>{season_0.display}</span></button>;
      $[46] = onSelect;
      $[47] = selected?.id;
      $[48] = t24;
    } else {
      t24 = $[48];
    }
    t23 = seasons.map(t24);
    $[42] = onSelect;
    $[43] = seasons;
    $[44] = selected?.id;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  let t24;
  if ($[49] !== isOpen || $[50] !== t22 || $[51] !== t23) {
    t24 = <SeasonsGridDropdownItemsWrapper isOpen={isOpen} setOpen={setIsOpen} buttonRef={buttonRef} filterLabel="Season">{t22}{t23}</SeasonsGridDropdownItemsWrapper>;
    $[49] = isOpen;
    $[50] = t22;
    $[51] = t23;
    $[52] = t24;
  } else {
    t24 = $[52];
  }
  let t25;
  if ($[53] !== t18 || $[54] !== t24) {
    t25 = <div className="tailwind-scope tw-w-full tw-h-full">{t18}{t24}</div>;
    $[53] = t18;
    $[54] = t24;
    $[55] = t25;
  } else {
    t25 = $[55];
  }
  return t25;
}
function _temp(error) {
  if (error instanceof DOMException && error.name === "AbortError") {
    return;
  }
  console.error("Failed to fetch meme seasons:", error);
}